var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { mq, styled } from "../../../utils";
var ListItem = styled.li(function (_a) {
    var markdown = _a.theme.components.markdown;
    return mq(markdown.text);
});
var ListItemRenderer = function (props) { return React.createElement(ListItem, __assign({}, props)); };
export default ListItemRenderer;
//# sourceMappingURL=ListItemRenderer.js.map